export const V_MENU = [
  {
    title: "Black Quality",
    menu: [
      {
        title: "Dashboard",
        icon1: "home",
        menu: [
          {
            title: "Default",
            url: `${process.env.PUBLIC_URL}/dashboard/default`,
          },
          {
            title: "Ecommerce",
            url: `${process.env.PUBLIC_URL}/dashboards/ecommerce`,
          },
        ],
      },
      {
        title: "Widgets",
        icon1: "widget",
        menu: [
          {
            title: "General",
            url: `${process.env.PUBLIC_URL}/widgets/general-widget`,
          },
          {
            title: "Chart",
            url: `${process.env.PUBLIC_URL}/widgets/chart-widget`,
          },
        ],
      },
      {
        title: "Page Layout",
        icon1: "layout",
        menu: [
          {
            title: "Hide Nav Scroll",
            url: `${process.env.PUBLIC_URL}/page-layout/hide-nav-scroll`,
          },
          {
            title: "Footer Dark",
            url: `${process.env.PUBLIC_URL}/page-layout/footer-dark`,
          },

          {
            title: "Footer Fixed",
            url: `${process.env.PUBLIC_URL}/page-layout/footer-fixed`,
          },
        ],
      },
    ],
  },
  {
    title: "Applications",
    menu: [
      {
        title: "Project",
        icon1: "project",
        menu: [
          {
            title: "Project List",
            url: `${process.env.PUBLIC_URL}/project/project-list`,
          },
          {
            title: "Create New",
            url: `${process.env.PUBLIC_URL}/project/create-project`,
          },
        ],
      },
      {
        title: "File Manager",
        icon1: "file",
        url: `${process.env.PUBLIC_URL}/file-manager`,
      },
      {
        title: "Ecommerce",
        icon1: "ecommerce",
        menu: [
          {
            title: "Product",
            url: `${process.env.PUBLIC_URL}/ecommerce/product`,
          },
          {
            title: "Product Page",
            url: `${process.env.PUBLIC_URL}/ecommerce/product-page`,
          },
          {
            title: "Product List",
            url: `${process.env.PUBLIC_URL}/ecommerce/product-list`,
          },
          {
            title: "Payment Details",
            url: `${process.env.PUBLIC_URL}/ecommerce/payment-details`,
          },
          {
            title: "Order History",
            url: `${process.env.PUBLIC_URL}/ecommerce/order-history`,
          },
          {
            title: "Invoice",
            url: `${process.env.PUBLIC_URL}/ecommerce/invoice`,
          },
          {
            title: "Cart",
            url: `${process.env.PUBLIC_URL}/ecommerce/cart`,
          },
          {
            title: "Wishlist",
            url: `${process.env.PUBLIC_URL}/ecommerce/wishlist`,
          },
          {
            title: "Checkout",
            url: `${process.env.PUBLIC_URL}/ecommerce/checkout`,
          },
          {
            title: "Pricing",
            url: `${process.env.PUBLIC_URL}/ecommerce/pricing`,
          },
        ],
      },
      {
        title: "Email",
        icon1: "email",
        menu: [
          {
            title: "Email App",
            url: `${process.env.PUBLIC_URL}/email/email-app`,
          },
          {
            title: "Email Compose",
            url: `${process.env.PUBLIC_URL}/email/email-compose`,
          },
        ],
      },
      {
        title: "Chat",
        icon1: "chat",
        menu: [
          {
            title: "Chat App",
            url: `${process.env.PUBLIC_URL}/chat/chat`,
          },
          {
            title: "Video chat",
            url: `${process.env.PUBLIC_URL}/chat/chat-video`,
          },
        ],
      },
      {
        title: "Users",
        icon1: "user",
        menu: [
          {
            title: "Users Profile",
            url: `${process.env.PUBLIC_URL}/users/user-profile`,
          },
          {
            title: "Users Edit",
            url: `${process.env.PUBLIC_URL}/users/edit-profile`,
          },
          {
            title: "Users Cards",
            url: `${process.env.PUBLIC_URL}/users/user-cards`,
          },
        ],
      },
      {
        title: "Bookmarks",
        icon1: "bookmark",
        url: `${process.env.PUBLIC_URL}/bookmark`,
      },
      {
        title: "Contacts",
        icon1: "contact",
        url: `${process.env.PUBLIC_URL}/contacts`,
      },
      {
        title: "Tasks",
        icon1: "task",
        url: `${process.env.PUBLIC_URL}/task`,
      },
      {
        title: "Calender",
        icon1: "calender",
        url: `${process.env.PUBLIC_URL}/calendar-basic`,
      },
      {
        title: "Social App",
        icon1: "social",
        url: `${process.env.PUBLIC_URL}/social-app`,
      },
      {
        title: "To-Do",
        icon1: "to-do",
        url: `${process.env.PUBLIC_URL}/to-do`,
      },
      {
        title: "Search Result",
        icon1: "search",
        url: `${process.env.PUBLIC_URL}/search`,
      },
    ],
  },
  {
    title: "Forms",
    menu: [
      {
        title: "Form",
        icon1: "form",
        menu: [
          {
            title: "Form Controls",
            menu: [
              {
                title: "Form Validation",
                url: `${process.env.PUBLIC_URL}/form-controls/form-validation`,
              },
              {
                title: "Base Inputs",
                url: `${process.env.PUBLIC_URL}/form-controls/base-input`,
              },
              {
                title: "Checkbox & Radio",
                url: `${process.env.PUBLIC_URL}/form-controls/radio-checkbox-control`,
              },
              {
                title: "Input Groups",
                url: `${process.env.PUBLIC_URL}/form-controls/input-group`,
              },
              {
                title: "Mega Options",
                url: `${process.env.PUBLIC_URL}/form-controls/mega-options`,
              },
            ],
          },
          {
            title: "Form Widgets",
            menu: [
              {
                title: "Datepicker",
                url: `${process.env.PUBLIC_URL}/forms/form-widgets/datepicker`,
              },
              {
                title: "Touch Spin",
                url: `${process.env.PUBLIC_URL}/forms/form-widgets/touch-spin`,
              },
              {
                title: "Switch",
                url: `${process.env.PUBLIC_URL}/forms/form-widgets/switch`,
              },
              {
                title: "Typeahead",
                url: `${process.env.PUBLIC_URL}/forms/form-widgets/typeahead`,
              },
              {
                title: "Clipboard",
                url: `${process.env.PUBLIC_URL}/forms/form-widgets/clipboard`,
              },
            ],
          },
          {
            title: "Form Layout",
            menu: [
              {
                title: "Form Wizard 1",
                url: `${process.env.PUBLIC_URL}/forms/form-layout/form-wizard-1`,
              },
              {
                title: "Form Wizard 2",
                url: `${process.env.PUBLIC_URL}/forms/form-layout/form-wizard-2`,
              },
              {
                title: "Two Factor",
                url: `${process.env.PUBLIC_URL}/forms/form-layout/two-factor`,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Tables",
    menu: [
      {
        title: "Table",
        icon1: "table",
        menu: [
          {
            title: "Bootstrap Tables",
            menu: [
              {
                title: "Basic Tables",
                url: `${process.env.PUBLIC_URL}/form/bootstrap-tables/basic-table`,
              },
              {
                title: "Table Componants",
                url: `${process.env.PUBLIC_URL}/form/bootstrap-tables/table-componants`,
              },
            ],
          },
          {
            title: "Data Tables",
            menu: [
              {
                title: "Basic Init",
                url: `${process.env.PUBLIC_URL}/form/data-tables/basic-init`,
              },
              {
                title: "Advance Init",
                url: `${process.env.PUBLIC_URL}/form/data-tables/advance-init`,
              },
              {
                title: "API",
                url: `${process.env.PUBLIC_URL}/form/data-tables/api`,
              },
              {
                title: "Data Sources",
                url: `${process.env.PUBLIC_URL}/form/data-tables/data-sources`,
                type: "link",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Components",
    menu: [
      {
        title: "Ui Kits",
        icon1: "ui-kits",
        menu: [
          {
            title: "Typography",
            url: `${process.env.PUBLIC_URL}/ui-kits/typography`,
          },
          {
            title: "Avatars",
            url: `${process.env.PUBLIC_URL}/ui-kits/avatars`,
          },
          {
            title: "Helper Classes",
            url: `${process.env.PUBLIC_URL}/ui-kits/helper-classes`,
          },
          {
            title: "Grid",
            url: `${process.env.PUBLIC_URL}/ui-kits/grid`,
          },
          {
            title: "Tag & Pills",
            url: `${process.env.PUBLIC_URL}/ui-kits/tag-pills`,
          },
          {
            title: "Progress",
            url: `${process.env.PUBLIC_URL}/ui-kits/progress-bar`,
          },
          {
            title: "Modal",
            url: `${process.env.PUBLIC_URL}/ui-kits/modal-bar`,
          },
          {
            title: "Alert",
            url: `${process.env.PUBLIC_URL}/ui-kits/alert`,
          },
          {
            title: "Popover",
            url: `${process.env.PUBLIC_URL}/ui-kits/popover`,
          },
          {
            title: "Tooltip",
            url: `${process.env.PUBLIC_URL}/ui-kits/tooltip`,
          },
          {
            title: "Dropdown",
            url: `${process.env.PUBLIC_URL}/ui-kits/dropdown`,
          },
          {
            title: "Accordion",
            url: `${process.env.PUBLIC_URL}/ui-kits/accordion`,
          },
          {
            title: "Tabs",
            url: `${process.env.PUBLIC_URL}/ui-kits/tabs`,
          },
          {
            title: "Lists",
            url: `${process.env.PUBLIC_URL}/ui-kits/lists`,
          },
        ],
      },
      {
        title: "Bonus Ui",
        icon1: "bonus-kit",
        menu: [
          {
            title: "Scrollable",
            url: `${process.env.PUBLIC_URL}/bonus-ui/scrollable`,
          },
          {
            title: "Tree View",
            url: `${process.env.PUBLIC_URL}/bonus-ui/tree`,
          },
          {
            title: "Toasts",
            url: `${process.env.PUBLIC_URL}/bonus-ui/toasts`,
          },
          {
            title: "Rating",
            url: `${process.env.PUBLIC_URL}/bonus-ui/rating`,
          },
          {
            title: "Dropzone",
            url: `${process.env.PUBLIC_URL}/bonus-ui/dropzone`,
          },
          {
            title: "Tour",
            url: `${process.env.PUBLIC_URL}/bonus-ui/tour`,
          },
          {
            title: "SweetAlert 2",
            url: `${process.env.PUBLIC_URL}/bonus-ui/sweet-alert-2`,
          },
          {
            title: "Carousel",
            url: `${process.env.PUBLIC_URL}/bonus-ui/carousel`,
          },
          {
            title: "Ribbons",
            url: `${process.env.PUBLIC_URL}/bonus-ui/ribbons`,
          },
          {
            title: "Pagination",
            url: `${process.env.PUBLIC_URL}/bonus-ui/pagination`,
          },
          {
            title: "Breadcrumb",
            url: `${process.env.PUBLIC_URL}/bonus-ui/breadcrumb`,
          },
          {
            title: "Range Slider",
            url: `${process.env.PUBLIC_URL}/bonus-ui/range-slider`,
          },
          {
            title: "Image Cropper",
            url: `${process.env.PUBLIC_URL}/bonus-ui/image-cropper`,
          },
          {
            title: "Basic Card",
            url: `${process.env.PUBLIC_URL}/bonus-ui/basic-card`,
          },
          {
            title: "Creative Card",
            url: `${process.env.PUBLIC_URL}/bonus-ui/creative-card`,
          },
          {
            title: "Timeline",
            url: `${process.env.PUBLIC_URL}/bonus-ui/timeline`,
          },
        ],
      },
      {
        title: "Icons",
        icon1: "icons",
        menu: [
          {
            title: "Flag Icon",
            url: `${process.env.PUBLIC_URL}/icons/flag-icon`,
          },
          {
            title: "Fontawesome Icon",
            url: `${process.env.PUBLIC_URL}/icons/font-awesome`,
          },
          {
            title: "Ico Icon",
            url: `${process.env.PUBLIC_URL}/icons/ico-icon`,
          },
          {
            title: "Themify Icon",
            url: `${process.env.PUBLIC_URL}/icons/themify-icon`,
          },
          {
            title: "Feather Icon",
            url: `${process.env.PUBLIC_URL}/icons/feather-icon`,
          },
          {
            title: "Whether Icon",
            url: `${process.env.PUBLIC_URL}/icons/whether-icon`,
          },
        ],
      },
      {
        title: "Buttons",
        icon1: "button",
        menu: [
          {
            title: "Default Style",
            url: `${process.env.PUBLIC_URL}/buttons/buttons`,
          },
          {
            title: "Flate Style",
            url: `${process.env.PUBLIC_URL}/buttons/flate-style`,
          },
          {
            title: "Edge Style",
            url: `${process.env.PUBLIC_URL}/buttons/edge-style`,
          },
          {
            title: "Raised Style",
            url: `${process.env.PUBLIC_URL}/buttons/raised-style`,
          },
          {
            title: "Button Group",
            url: `${process.env.PUBLIC_URL}/buttons/button-group`,
          },
        ],
      },
      {
        title: "Charts",
        icon1: "charts",
        menu: [
          {
            title: "Apex Chart",
            url: `${process.env.PUBLIC_URL}/charts/chart-apex`,
          },
          {
            title: "Google Chart",
            url: `${process.env.PUBLIC_URL}/charts/chart-google`,
          },
          {
            title: "Chatjs Chart",
            url: `${process.env.PUBLIC_URL}/charts/chartjs`,
          },
        ],
      },
    ],
  },
  {
    title: "Others",
    menu: [
      {
        title: "Other",
        icon1: "others",
        menu: [
          {
            title: "Sample Page",
            url: `${process.env.PUBLIC_URL}/pages/sample-page`,
          },
          {
            title: "Error Page",
            menu: [
              {
                title: "Error 400",
                url: `${process.env.PUBLIC_URL}/others/error-400`,
              },
              {
                title: "Error 401",
                url: `${process.env.PUBLIC_URL}/others/error-401`,
              },
              {
                title: "Error 403",
                url: `${process.env.PUBLIC_URL}/others/error-403`,
              },
              {
                title: "Error 404",
                url: `${process.env.PUBLIC_URL}/others/error-404`,
              },
              {
                title: "Error 500",
                url: `${process.env.PUBLIC_URL}/others/error-500`,
              },
              {
                title: "Error 503",
                url: `${process.env.PUBLIC_URL}/others/error-503`,
              },
            ],
          },
          {
            title: "Authentication",
            menu: [
              {
                title: "Login Simple",
                url: `${process.env.PUBLIC_URL}/auth/login`,
              },
              {
                title: "Login With Bg Image",
                url: `${process.env.PUBLIC_URL}/auth/login-bg-img`,
              },
              {
                title: "Login With Image Two",
                url: `${process.env.PUBLIC_URL}/auth/login-bg-img2`,
              },
              {
                title: "Login With Validation",
                url: `${process.env.PUBLIC_URL}/auth/login-bs-validation`,
              },
              {
                title: "Login With Tooltip",
                url: `${process.env.PUBLIC_URL}/auth/login-bs-tt-validation`,
              },
              {
                title: "Login With Sweetalert",
                url: `${process.env.PUBLIC_URL}/auth/login-sa-validation`,
              },
              {
                title: "Register Simple",
                url: `${process.env.PUBLIC_URL}/auth/sign-up`,
              },
              {
                title: "Register With Bg Image",
                url: `${process.env.PUBLIC_URL}/auth/sign-up-one`,
              },
              {
                title: "Register With Image Two",
                url: `${process.env.PUBLIC_URL}/auth/sign-up-two`,
              },
              {
                title: "Register Wizard",
                url: `${process.env.PUBLIC_URL}/auth/sign-up-wizard`,
              },
              {
                title: "Unlock User",
                url: `${process.env.PUBLIC_URL}/auth/unlock`,
              },
              {
                title: "Forget Password",
                url: `${process.env.PUBLIC_URL}/auth/forget-password`,
              },
              {
                title: "Reset Password",
                url: `${process.env.PUBLIC_URL}/auth/reset-password`,
              },
              {
                title: "Maintenance",
                url: `${process.env.PUBLIC_URL}/auth/maintenance`,
              },
            ],
          },
          {
            title: "Coming Soon",
            menu: [
              {
                title: "Coming Simple",
                url: `${process.env.PUBLIC_URL}/coming-soon/coming-soon`,
              },
              {
                title: "Coming with Bg video",
                url: `${process.env.PUBLIC_URL}/coming-soon/coming-soon-bg-video`,
              },
              {
                title: "Coming with Bg Image",
                url: `${process.env.PUBLIC_URL}/coming-soon/coming-soon-bg-img`,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Miscellaneous",
    menu: [
      {
        title: "Gallery",
        icon1: "gallery",
        menu: [
          {
            title: "Gallery Grid",
            url: `${process.env.PUBLIC_URL}/gallery/gallery`,
          },
          {
            title: "Gallery Grid Desc",
            url: `${process.env.PUBLIC_URL}/gallery/gallery-with-description`,
          },
          {
            title: "Masonry Gallery",
            url: `${process.env.PUBLIC_URL}/gallery/gallery-masonry`,
          },
          {
            title: "Masonry With Desc",
            url: `${process.env.PUBLIC_URL}/gallery/masonry-gallery-with-disc`,
          },
          {
            title: "Hover Effects",
            url: `${process.env.PUBLIC_URL}/gallery/gallery-hover`,
          },
        ],
      },
      {
        title: "Blog",
        icon1: "blog",
        menu: [
          {
            title: "Blog Details",
            url: `${process.env.PUBLIC_URL}/blog/blog-detail`,
          },
          {
            title: "Blog Single",
            url: `${process.env.PUBLIC_URL}/blog/blog-single`,
          },
          {
            title: "Add Post",
            url: `${process.env.PUBLIC_URL}/blog/add-post`,
          },
        ],
      },
      {
        title: "FAQ",
        icon1: "faq",
        url: `${process.env.PUBLIC_URL}/faq`,
      },
      {
        title: "Job Search",
        icon1: "job-search",
        menu: [
          {
            title: "Cards View",
            url: `${process.env.PUBLIC_URL}/job-search/job-cards-view`,
          },
          {
            title: "List View",
            url: `${process.env.PUBLIC_URL}/job-search/job-list-view`,
          },
          {
            title: "Job Details",
            url: `${process.env.PUBLIC_URL}/job-search/job-details`,
          },
          {
            title: "Apply",
            url: `${process.env.PUBLIC_URL}/job-search/job-apply`,
          },
        ],
      },
      {
        title: "Learning",
        icon1: "learning",
        menu: [
          {
            title: "Learning List",
            url: `${process.env.PUBLIC_URL}/learning/learning-list-view`,
          },
          {
            title: "Detailed Course",
            url: `${process.env.PUBLIC_URL}/learning/learning-detail`,
          },
        ],
      },
      {
        title: "Maps",
        icon1: "maps",
        menu: [
          {
            title: "Google Map",
            url: `${process.env.PUBLIC_URL}/maps/google-map`,
          },
          {
            title: "Leaflet Map",
            url: `${process.env.PUBLIC_URL}/maps/leaflet-map`,
          },
        ],
      },
      {
        title: "Editors",
        icon1: "editors",
        menu: [
          {
            title: "CK Editor",
            url: `${process.env.PUBLIC_URL}/editors/ck-editor`,
          },
          {
            title: "MDE Editor",
            url: `${process.env.PUBLIC_URL}/editors/simple-MDE`,
          },
          {
            title: "ACE Code Editor",
            url: `${process.env.PUBLIC_URL}/editors/acecode-editor`,
          },
        ],
      },
      {
        title: "Knowledgebase",
        icon1: "knowledgebase",
        url: `${process.env.PUBLIC_URL}/knowledgebase/knowledgebase`,
      },
      {
        title: "Support Ticket",
        icon1: "support-tickets",
        url: `${process.env.PUBLIC_URL}/support-ticket`,
      },
    ],
  },
];
